// Copyright (c) 2019 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import ClaimIncentive, {getDefaultState as getIncentiveDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-incentive';
import ConfirmationModal, {getDefaultState as getConfirmationModalDefaultState} from '../../shared/state/confirmation-modal';
import CreateClaimModalType, {getDefaultState as getCreateClaimModalTypeDefaultState} from '../../../shared/state/create-claim-modal';
import Customer, {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import FormValidation, {getDefaultState as getDefaultFormValidationState} from './form-validation';
import Pin, {getDefaultState as getPinDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pin';
import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import WarrantyStatusModal, {getDefaultState as getWarrantyStatusModal} from '../../../../src/claim/shared/state/warranty-status-modal';
import t from 'tcomb';

const IncentiveClaim = t.struct({
    busyCounter: BusyCounter,
    claim: ClaimIncentive,
    confirmationModal: ConfirmationModal,
    createClaimModal: CreateClaimModalType,
    customer: Customer,
    formValidation: FormValidation,
    isActionButtonDisabled: t.Boolean,
    isCopied: t.Boolean,
    isEditable: t.Boolean,
    isNonTrackedPinModalVisible: t.Boolean,
    pin: Pin,
    product: Product,
    showApplyTravel: t.Boolean,
    temporaryObjectKey: t.String,
    warrantyStatusModal: WarrantyStatusModal

}, 'IncentiveClaim');

export const getDefaultState = () => new IncentiveClaim({
    busyCounter: getBusyCounterDefaultState(),
    claim: getIncentiveDefaultState(),
    confirmationModal: getConfirmationModalDefaultState(),
    createClaimModal: getCreateClaimModalTypeDefaultState(),
    customer: getCustomerDefaultState(),
    formValidation: getDefaultFormValidationState(),
    isActionButtonDisabled: false,
    isCopied: false,
    isEditable: true,
    isNonTrackedPinModalVisible: false,
    pin: getPinDefaultState(),
    product: getProductDefaultState(),
    showApplyTravel: false,
    temporaryObjectKey: '',
    warrantyStatusModal: getWarrantyStatusModal()
});

export default IncentiveClaim;



// WEBPACK FOOTER //
// ./src/claim/incentive/state/index.js